import { ICompanyDataModel } from './company.data-model';

export interface IDealStatItemDataModel {
  company: Pick<ICompanyDataModel, 'logoUrl' | 'name'>;
  createdAt: string;
  id: number;
  roundId: number;
}

export function createDealStatItemDataModel(
  overrides: Partial<IDealStatItemDataModel> = {}
): IDealStatItemDataModel {
  return {
    id: 0,
    roundId: 0,
    company: {
      logoUrl: '',
      name: '',
    },
    createdAt: new Date().toISOString(),
    ...overrides,
  };
}

export interface IDealStageStatsDataModel {
  duration: number;
  name: string;
  sortOrder: number;
}

export function createDealStageStatsDataModel(
  overrides: Partial<IDealStageStatsDataModel> = {}
): IDealStageStatsDataModel {
  return {
    duration: 0,
    name: '',
    sortOrder: 0,
    ...overrides,
  };
}

export interface IDealStatsDataModel {
  deal: IDealStatItemDataModel;
  stages: IDealStageStatsDataModel[];
}

export function createDealStatsDataModel(overrides: Partial<IDealStatsDataModel> = {}): IDealStatsDataModel {
  return {
    deal: createDealStatItemDataModel(),
    stages: [createDealStageStatsDataModel()],
    ...overrides,
  };
}
